import { render } from "./CategoriesDetailsModal.vue?vue&type=template&id=5ab81f0f&scoped=true"
import script from "./CategoriesDetailsModal.vue?vue&type=script&lang=js"
export * from "./CategoriesDetailsModal.vue?vue&type=script&lang=js"

import "./CategoriesDetailsModal.vue?vue&type=style&index=0&id=5ab81f0f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab81f0f"]])

export default __exports__